import * as jsxRuntime from "D:\\GitHubProjects\\na-authority-erp\\src\\authority-payroll-portal\\AuthorityPayrollPortal\\node_modules\\react\\jsx-runtime.js"
export const jsx = jsxRuntime.jsx
export const jsxs = jsxRuntime.jsxs
export const Fragment = jsxRuntime.Fragment